<span class="label">{{ metadata.label }}</span>

<ng-container *ngFor="let value of metadata.values">
  <span *ngIf="!value.queryParams && !value.externalLink" class="value">{{ value.text }}</span>

  <a
    *ngIf="value.queryParams"
    class="value"
    [queryParams]="{ query: value.queryParams }"
    [title]="metadata.label + ' ' + value.text"
    routerLink="/results"
    >{{ value.text }}</a
  >
  <a
    *ngIf="value.externalLink"
    [href]="value.externalLink.link"
    target="_blank"
    rel="noopener"
    [opacTooltip]="metadata.label + ' ' + value.text">
    <img [src]="value.externalLink.imageUrl" [alt]="value.text" loading="lazy"
  /></a>
</ng-container>
